import {
  Component,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  QueryList,
  AfterViewInit,
  ViewChildren,
} from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW0002Model } from './kymw0002.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { FlexGrid, CellType } from '@grapecity/wijmo.grid';
import { DropDown } from '@grapecity/wijmo.input';
import { WjFlexGrid } from '@grapecity/wijmo.angular2.grid';
import { WjAutoComplete } from '@grapecity/wijmo.angular2.input';
import { WjAccordion } from '@grapecity/wijmo.angular2.nav';
import { EventArgs } from '@grapecity/wijmo';
import { GetTagGroupListService } from './api-services/get-tag-group-list.service';
import { TagGroupInfo } from './vo/tag-group-info.model';
import { KYMW0002OutputModel } from './vo/kymw0002-output.model';
import { KYMW0002InputModel } from './vo/kymw0002-input.model';
import { PlessViewUtilsSub } from '../pless-view-utils-sub.service';

/**
 * タグ選択を管理するクラス
 *
 * @export KYMW0002Component
 * @class KYMW0002Component
 */
@Component({
  selector: 'app-kymw0002',
  templateUrl: 'kymw0002.component.html',
  styleUrls: ['kymw0002.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW0002Component
  extends PlessViewHelperSub
  implements OnInit, AfterViewInit
{
  public model: KYMW0002Model = new KYMW0002Model();

  private static readonly MAX_LENGTH_TAGNAME = 30;

  @ViewChildren(WjFlexGrid) dtgs: QueryList<WjFlexGrid>;
  @ViewChild('wac_TagName', { static: false }) wac_TagName: WjAutoComplete;

  /**
   * Creates an instance of KYMW0002Component.
   *
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetTagGroupListService} getTagGroupListService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0002Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private getTagGroupListService: GetTagGroupListService,
    private kymw00Model: KYMW00Model
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW0002Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW0002';

    const calbak = () => {
      // 親画面から連携されたタグIDをチェックTrueに変更
      this.model.tagGroupListForEdit.forEach(_g =>
        _g.tags
          .filter(_t => this.model.selectedTagIdList.includes(_t.tagId))
          .forEach(_t => (_t.check = true))
      );
      this.model.tagGroupListForEdit.forEach(_g => {
        if (_g.tags.some(_t => this.model.selectedTagIdList.includes(_t.tagId)))
          _g.open = true;
      });
    };
    // 画面初期表示のAPIリクエスト
    this.getTagGroupListService.execute(this.model, calbak);
  }

  /**
   * ビュー初期化
   *
   * @memberof KYMW0002Component
   */
  public ngAfterViewInit(): void {
    // グリッドの初期状態で選択無効 チェックボックスのあたり判定制御
    if (this.dtgs)
      this.dtgs.changes.subscribe(e => {
        e.forEach(_g => {
          _g.itemsSourceChanged.addHandler((_f: FlexGrid, _e: EventArgs) => {
            _f.select(-1, -1);
          });
          _g.hostElement.addEventListener('click', e => {
            const ht = _g.hitTest(e.pageX, e.pageY);
            if (ht.cellType === CellType.Cell && ht.col === 0) {
              const id = _g.itemsSource.find((e, i) => ht.row === i)?.tagId;
              this.checkCell(id);
            }
          });
        });
      });
    if (this.wac_TagName) {
      this.wac_TagName.textChanged.addHandler((d: DropDown, e: EventArgs) => {
        d.text = PlessViewUtilsSub.halfToFull(d.text);
        if (d.text.length > KYMW0002Component.MAX_LENGTH_TAGNAME)
          d.text = d.text.substring(0, KYMW0002Component.MAX_LENGTH_TAGNAME);
      });
    }
  }

  /**
   * タグ名 入力制限
   */
  public inputRestrict(sender: any) {
    const newValue = PlessViewUtilsSub.doInputRestrict(sender.text);

    if (newValue !== sender.text) sender.text = newValue;
  }

  /**
   * Grid初期処理
   *
   * @param grid
   */
  onInitialized(grid: FlexGrid) {
    grid.select(-1, -1);
  }

  /**
   * ボタン押下 タグ名絞込
   *
   * @memberof KYMW0002Component
   */
  public filter() {
    // 桁数
    if (this.wac_TagName.text.length > KYMW0002Component.MAX_LENGTH_TAGNAME) {
      this.dialogService.openAlertGetMessage('W0007', [
        'タグ名',
        KYMW0002Component.MAX_LENGTH_TAGNAME.toString(),
      ]);
      return;
    }
    const selected = new Set<string>();
    this.model.tagGroupListForEdit.forEach(_g =>
      _g.tags.filter(_t => _t.check).forEach(_t => selected.add(_t.tagId))
    );
    this.model.tagGroupListForEdit = this.model.tagGroupListOrigin.map(
      _ => new TagGroupInfo(_.tagGroupId, _.tagGroupName, new Array(..._.tags))
    );
    this.model.tagGroupListForEdit.forEach(_g =>
      _g.tags
        .filter(_t => Array.from(selected).includes(_t.tagId))
        .forEach(_t => (_t.check = true))
    );
    // 空文字の場合はグリッドを初期に戻す
    if (!this.wac_TagName.text) {
      this.model.tagGroupListForEdit.forEach(_g => {
        if (_g.tags.some(_t => _t.check)) _g.open = true;
      });
    }
    this.model.tagGroupListForEdit.forEach(
      _g =>
        (_g.tags = _g.tags.filter(_t =>
          _t.tagName.startsWith(this.wac_TagName.text)
        ))
    );
    this.model.tagGroupListForEdit.forEach(_g => {
      if (_g.tags.some(_t => _t.check)) _g.open = true;
    });

    // 絞り込み結果が0件であればエラーメッセージ表示
    if (!this.model.dspTagGroupList.length) {
      this.dialogService.openAlertGetMessage('E0100');
    }
  }

  /**
   * チェックボックス入力
   * 異なるタググループ間でタグIDのチェックボックスを同期
   *
   * @memberof KYMW0002Component
   */
  public checkCell(tId: string) {
    if (!tId) return;
    const val = this.model.tagGroupListForEdit
      .find(_ => _.tags.map(_ => _.tagId).includes(tId))
      ?.tags.find(_t => tId === _t.tagId)?.check;
    if (typeof val !== 'boolean') return;
    this.model.tagGroupListForEdit.forEach(_g =>
      _g.tags.filter(_t => tId === _t.tagId).forEach(_t => (_t.check = !val))
    );
  }

  /**
   * ボタン押下 選択
   *
   * @memberof KYMW0002Component
   */
  public Choose(): void {
    this.model.output = null;
    const tagSet = this.model.tagGroupListForEdit.reduce(
      (_s: Set<KYMW0002OutputModel[number]>, _e: TagGroupInfo) => {
        _e.tags
          .filter(_t => _t.check)
          .forEach(_t => {
            if (!new Array(..._s).map(_ => _.tagId).includes(_t.tagId))
              _s.add({ tagId: _t.tagId, tagName: _t.tagName });
          });
        return _s;
      },
      new Set()
    );
    this.model.output = new Array(...tagSet);
    this.closeFunction();
  }

  /**
   * パラメータ格納 呼び出し側から利用
   *
   * @param params
   * @memberof KYMW0002Component
   */
  public setParams(params: KYMW0002InputModel): void {
    this.model.selectedTagIdList = params;
  }

  /**
   * パラメータ取得 呼び出し側から利用
   *
   * @param params
   * @memberof KYMW0002Component
   */
  public getParams(): KYMW0002OutputModel {
    return this.model.output;
  }

  public initCollapsed(wad: WjAccordion, collapsed: boolean = true) {
    wad.panes.forEach(_ => (_.isCollapsed = collapsed));
  }
}
